import Model, { Request } from '../model'
import Enum from '../enums'
import APIObject from '../object'

import Customer from './customer'
import Order from './order'

export default class PaymentRequest extends Model {
  static modelName () {
    return 'paymentRequest'
  }

  objectID () {
    return this.idOrderPaymentRequest
  }

  relations () {
    return {
      status: { type: PaymentRequestStatus },
    }
  }

  get isStatusRequested () {
    return this.status === PaymentRequestStatus.requested
  }

  get isStatusScheduled () {
    return this.status === PaymentRequestStatus.scheduled
  }

  get isStatusPaid () {
    return this.status === PaymentRequestStatus.paid
  }

  get isStatusExpired () {
    return this.status === PaymentRequestStatus.expired
  }

  get isStatusCancelled () {
    return this.status === PaymentRequestStatus.cancelled
  }
}

export const PaymentRequestStatus = new Enum({
  requested: { value: 0, description: 'api.models.paymentRequest.requested' },
  scheduled: { value: 1, description: 'api.models.paymentRequest.scheduled' },
  paid: { value: 2, description: 'api.models.paymentRequest.paid' },
  expired: { value: 3, description: 'api.models.paymentRequest.expired' },
  cancelled: { value: 4, description: 'api.models.paymentRequest.cancelled' },
})
